export default class Advisors{
    constructor(section){
        this.section = section;
        this.voivodeshipSelect = section.querySelector('select[name="voivodeship"]');
        this.countySelect = section.querySelector('select[name="county"]');
        this.countyLegend = section.querySelector('.legend-item[data-name="county"] span');
        this.voivodeshipLegend = section.querySelector('.legend-item[data-name="voivodeship"] span');
        this.form = section.querySelector('form');
        this.advisors = section.querySelectorAll('.advisor');
        this.init();
    }

    init(){
        this.fillCounties();
        this.voivodeshipSelect.addEventListener('change', () => {
            this.fillCounties();
        });

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            let voivodeship = this.voivodeshipSelect.value;
            let county = this.countySelect.value;
            if (county){
                this.countyLegend.innerHTML = regions[voivodeship].counties[county].name;
                this.countyLegend.parentNode.classList.add('active');
            }else{
                this.countyLegend.parentNode.classList.remove('active');
                this.countyLegend.innerHTML = '';
            }
            this.voivodeshipLegend.innerHTML = regions[voivodeship].name;
            this.voivodeshipLegend.parentNode.classList.add('active');
            this.advisors.forEach(advisor => {
                advisor.classList.remove('active');
                let regions = advisor.dataset.region.split(',');
                if (county && !voivodeship){
                    if (regions.includes(county)){
                        advisor.classList.add('active');
                    }
                }
                if (!county && voivodeship){
                    if (regions.includes(voivodeship)){
                        advisor.classList.add('active');
                    }
                }
                if (county && voivodeship){
                    if (regions.includes(voivodeship) && regions.includes(county)){
                        advisor.classList.add('active');
                    }
                }
            });
        });
    }
    fillCounties(){
        let voivodeship = this.voivodeshipSelect.value;
        if (voivodeship){
            let counties = regions[voivodeship].counties;
            console.log(voivodeship);
            console.log(regions[voivodeship]);
            if (counties){
                this.countySelect.querySelectorAll('option:not(:first-child)').forEach( el => {
                    el.remove();
                });
                for (const [key, county] of Object.entries(counties)){
                    let option = document.createElement('option');
                    option.value = county.slug;
                    option.innerHTML = county.name;
                    this.countySelect.append(option);
                    this.countySelect.querySelector('option:first-child').selected = 'selected';
                }
            }
        }
    }
}